import { render, staticRenderFns } from "./SendMsgCode.vue?vue&type=template&id=21222ce6&scoped=true&"
import script from "./SendMsgCode.vue?vue&type=script&lang=js&"
export * from "./SendMsgCode.vue?vue&type=script&lang=js&"
import style0 from "./SendMsgCode.vue?vue&type=style&index=0&id=21222ce6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21222ce6",
  null
  
)

export default component.exports